import React from 'react';
import './sections.css';

interface PageHeroProps {
    kicker: string;
    title: React.ReactNode;
    description: string;
    children?: React.ReactNode;
}

/** Dark banner used at the top of every inner page. */
const PageHero: React.FC<PageHeroProps> = ({ kicker, title, description, children }) => (
    <section className="page-hero">
        <div className="glow page-hero__glow" />
        <div className="container page-hero__inner">
            <span className="kicker">{kicker}</span>
            <h1>{title}</h1>
            <p className="lede">{description}</p>
            {children && <div className="page-hero__extra">{children}</div>}
        </div>
    </section>
);

export default PageHero;
